import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 22,
	viewBox: "0 0 13 22",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "phone_iphone_black_24dp_2_",
		"data-name": "phone_iphone_black_24dp (2)",
		d: "M15.5,1h-8A2.5,2.5,0,0,0,5,3.5v17A2.5,2.5,0,0,0,7.5,23h8A2.5,2.5,0,0,0,18,20.5V3.5A2.5,2.5,0,0,0,15.5,1Zm-4,21A1.5,1.5,0,1,1,13,20.5,1.5,1.5,0,0,1,11.5,22ZM16,18H7V4h9Z",
		transform: "translate(-5 -1)"
	})
});
export { SvgPhone as ReactComponent };
